import axios from 'axios';

export const getPresignedUrl = (objectType, contentType) =>
  axios.get('/api/aws/url', {
    params: {
      object_type: objectType,
      content_type: contentType,
    },
  });
